import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TrialKitRequest } from '../models';

@Injectable()
export class TrialKitService {
  constructor(private http: HttpClient) {}

  requestTrialKit(trialKitReq: TrialKitRequest) {
    return this.http.post(
      environment.trialKitRequestUrl,
      JSON.stringify(trialKitReq)      // to force Content-Type: text/plain
    );
  }
}
